import { ScreenSize } from '../utils/constants'
import useIsOnMobile from './useIsOnMobile'

const DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
} as const

 type DeviceType = typeof DEVICE_TYPES[keyof typeof DEVICE_TYPES]

/**
 * Hook that returns the current device type based on screen width
 * @returns The current device type as a string: 'mobile', 'tablet', or 'desktop'
 */
const useDeviceType = (): DeviceType => {
  const isMobile = useIsOnMobile(ScreenSize.sm)
  const isTablet = useIsOnMobile(ScreenSize.lg)

  if (isMobile) {
    return DEVICE_TYPES.MOBILE
  }

  if (isTablet) {
    return DEVICE_TYPES.TABLET
  }

  return DEVICE_TYPES.DESKTOP
}

export default useDeviceType
